import {
  QUERY_PARAMS_SHIFT_LEFT,
  QUERY_PARAMS_SHIFT_RIGHT,
  QUERY_PARAMS_ZOOM_OUT,
  SET_QUERY_AGGREGATION_LEVEL,
  SET_QUERY_PARAMS,
  SHIFT_QUERY_PARAMS,
  UPDATE_QUERY_PARAMS
} from '../constants/actionTypes';

export const aggregationLevelToSeconds = aggregationLevel => {
  switch (aggregationLevel) {
    case 'none':
      return 2;
    case 'minutes_1':
      return 60;
    case 'minutes_15':
      return 900;
    case 'hours_1':
      return 3600;
    case 'days_1':
      return 86400;
    default:
      return 3600;
  }
};

export const setQueryParams = payload => {
  return {
    type: SET_QUERY_PARAMS,
    payload
  };
};

export const updateQueryAggregationLevel = payload => {
  return {
    type: SET_QUERY_AGGREGATION_LEVEL,
    payload
  };
};

export const updateQueryParams = payload => {
  return {
    type: UPDATE_QUERY_PARAMS,
    payload
  };
};

export const shiftQueryParams = payload => {
  return {
    type: SHIFT_QUERY_PARAMS,
    payload
  };
};

export const queryParamsZoomOut = payload => {
  return {
    type: QUERY_PARAMS_ZOOM_OUT,
    payload
  };
};

export const queryParamsShiftLeft = payload => {
  return {
    type: QUERY_PARAMS_SHIFT_LEFT,
    payload
  };
};

export const queryParamsShiftRight = payload => {
  return {
    type: QUERY_PARAMS_SHIFT_RIGHT,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/queryParams.js